const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Station',
			DefaultInputExtensions: [ 'InputValidation', 'Station' ],
			Template: /*HTML*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="field has-addons has-addons-right mb-0">
						<p class="control control-status has-icons-left is-expanded">
							<span class="control-status-icon"></span>
							<input
								id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
								type="text"
								class="input {~ColumnAlignment:Record~}"
								{~D:Record.Macro.ControlAttr~}
								{~Required:Record~}
								{~Disabled:Record~}
								placeholder="{~Placeholder:Record~}"
								onchange="{~D:Record.Macro.DataRequestFunction~}"
								autocomplete="off"
								value=""
							/>
							<span class="icon is-small is-left">
								<i class="fas fa-sign-post fa-xs"></i>
							</span>
						</p>
					</div>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Station',
			DefaultInputExtensions: [ 'InputValidation', 'Station' ],
			Template: /*HTML*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									onchange="{~D:Record.Macro.DataRequestFunction~}"
									autocomplete="off"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-sign-post fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Station',
			DefaultInputExtensions: [ 'InputValidation', 'Station' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Station',
			Template: /*HTML-Partial*/`
					value=""
				/>
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="STATION-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input {~ColumnAlignment:Record~}"
						{~D:Record.Macro.ControlAttr~}
						{~Required:Record~}
						{~Disabled:Record~}
						{~D:Record.Macro.HTMLName~}
						placeholder="{~Placeholder:Record~}"
						onchange="_Pict.views['{~D:Context[0].Hash~}'].inputDataRequestTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')"
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-sign-post fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Station',
			DefaultInputExtensions: [ 'Station' ],
			Template: /*HTML*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control has-icons-left">
						<input
							id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							readonly aria-readonly="true"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-sign-post fa-xs"></i>
						</span>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Station',
			DefaultInputExtensions: [ 'Station' ],
			Template: /*HTML*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control has-icons-left">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="hidden"
									tabindex="-1"
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<input
									id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input {~ColumnAlignment:Record~}"
									{~D:Record.Macro.ControlAttr~}
									readonly aria-readonly="true"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-sign-post fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Station',
			DefaultInputExtensions: [ 'Station' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Station  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="STATION-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Station',
			Template: /*HTML-Partial*/`
				value=""
			/>
			<p class="control has-icons-left">
				<input
					id="STATION-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="text"
					class="input {~ColumnAlignment:Record~}"
					{~D:Record.Macro.ControlAttr~}
					readonly aria-readonly="true"
					{~D:Record.Macro.HTMLName~}
					value=""
				/>
				<span class="icon is-small is-left">
					<i class="fas fa-sign-post fa-xs"></i>
				</span>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Station',
			DefaultInputExtensions: [ 'Station' ],
			Template: /*HTML*/`
			<!-- DataType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Station',
			DefaultInputExtensions: [ 'Station' ],
			Template: /*HTML*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div
							id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static {~ColumnAlignment:Record~}"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Station',
			DefaultInputExtensions: [ 'Station' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Station {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="STATION-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="text"
				class="input {~ColumnAlignment:Record~}"
				readonly aria-readonly="true"
				{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Station',
			Template: /*HTML-Partial*/`
				value=""
			/>
			<div
				id="STATION-INPUT-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static {~ColumnAlignment:Record~}"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}>
			</div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
